<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ep1"> </p>
<p class="ep-bot"><span class="epub-i">We may make our plans, but God has the last word.</span></p>
<p class="epc"><span class="epub-sc">—PROVERBS 16:1</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph1.vue?9a4d8600